import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import Hail from "@mui/icons-material/Hail";
import SettingsAccessibility from "@mui/icons-material/SettingsAccessibility";
import Man from '@mui/icons-material/Man';
import InsertChartIcon from "@mui/icons-material/InsertChart";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SettingsSystemDaydreamOutlinedIcon from "@mui/icons-material/SettingsSystemDaydreamOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Link } from "react-router-dom";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext } from "react";
import image from '../../assets/logo.png'

const Sidebar = () => {
  const { dispatch } = useContext(DarkModeContext);
  return (
    <div className="sidebar">
      <div className="top">
        <Link to="/home" style={{ textDecoration: "none" }}>
        <div className='logoPortion'>
          <img className="imageLogo" src={image} alt="" />
           <h2>SPO</h2>  
          </div>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <Link to="/home" style={{ textDecoration: "none" }}>
          <li>
            <DashboardIcon className="icon" />
            <span>Dashboard</span>
          </li>
          </Link>

          <Link to="/home/users" style={{ textDecoration: "none" }}>
            <li>
              <HomeWorkIcon className="icon" />
              <span>Schools</span>
            </li>
          </Link>
          <Link to="/home/teacherList" style={{ textDecoration: "none" }}>
            <li>
              <Man className="icon" />
              <span>Teachers</span>
            </li>
          </Link>
          <Link to="/home/studentList" style={{ textDecoration: "none" }}>
          <li>
            <SettingsAccessibility className="icon" />
            <span>Students</span>
          </li>
          </Link>

          <Link to="/home/headteacherList" style={{ textDecoration: "none" }}>
          <li>
            <Hail className="icon" />
            <span>Head Teachers</span>
          </li>
          </Link>
          
          {/* <li>
            <InsertChartIcon className="icon" />
            <span>Stats</span>
          </li> */}
          {/* <li>
            <NotificationsNoneIcon className="icon" />
            <span>Notifications</span>
          </li> */}
          {/* <li>
            <SettingsSystemDaydreamOutlinedIcon className="icon" />
            <span>System Health</span>
          </li> */}
          {/* <li>
            <PsychologyOutlinedIcon className="icon" />
            <span>Logs</span>
          </li> */}
          {/* <li>
            <SettingsApplicationsIcon className="icon" />
            <span>Settings</span>
          </li> */}
          <Link to="/home/AdminProfile" style={{ textDecoration: "none" }}>
          <li>
            <AccountCircleOutlinedIcon className="icon" />
            <span>Profile</span>
          </li>
          </Link>
          
          <Link to="/" style={{ textDecoration: "none" }}>
          <li>
            <ExitToAppIcon className="icon" />
            <span>Logout</span>
          </li>
          </Link>
        </ul>
      </div>
      <div className="bottom">
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "LIGHT" })}
        ></div>
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "DARK" })}
        ></div>
      </div>
    </div>
  );
};

export default Sidebar;
